import { markRaw } from 'vue'
import type { RegisteredComponent } from '@builder.io/sdk-vue'
import BaseCarouselBuilderInternal from '~/components/BaseCarouselBuilderInternal.vue'

export default <RegisteredComponent>{
  name: 'Base Testimonial Carousel',
  tag: 'base-testimonial-carousel',
  type: 'vue',
  component: markRaw(BaseCarouselBuilderInternal),
  inputs: [
    {
      name: 'modelName',
      friendlyName: 'Model Name',
      helperText:
        'This is the model name that needs to be fetched from the Testimonial Carousel Data',
      type: 'string',
      defaultValue: 'Fallback Do Not Delete',
    },
    {
      name: 'canvasHeight',
      friendlyName: 'Canvas Height',
      helperText:
        'This is a string value to set the height of the canvas for the testimonials. Unit must be provided, example - 250px, 15rem',
      type: 'string',
      defaultValue: '15rem',
    },
    {
      name: 'autoplay',
      friendlyName: 'Enable autoplay',
      helperText: 'Enables automatic sliding on given interval',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'interval',
      friendlyName: 'Autoplay Interval (ms)',
      helperText:
        'This is the interval on how often the slides should change. It is set in milliseconds (ms) - 1000ms = 1sec. Default is 5000ms (5sec)',
      type: 'number',
      defaultValue: 5000,
    },
    {
      name: 'swipe',
      friendlyName: 'Enable swiping',
      helperText:
        'Enables swiping motion on mobile and desktop to navigate through slides.',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'swipeThreshold',
      friendlyName: 'Swipe Motion Threshold (px)',
      helperText:
        'The swipe threshold in pixels. This is the distance that the user would have to swipe in order to register a swipe motion. Default value: 100',
      type: 'number',
      defaultValue: 100,
    },
    {
      name: 'swipeOverflowBarrierColours',
      friendlyName: 'DEV ONLY - Swipe Barriers Overflow Colours',
      helperText:
        'DEV ONLY - Please ask a developer to help you with the colours for the gradient colours. Example - left: #ffffff right: #cccccc',
      type: 'object',
      defaultValue: {
        left: '#ffffff',
        right: '#ffffff',
      },
      subFields: [
        {
          name: 'left',
          type: 'color',
        },
        {
          name: 'right',
          type: 'color',
        },
      ],
    },
    {
      name: 'navigation',
      friendlyName: 'Enable navigation buttons',
      helperText: 'This will enable and show the navigation buttons',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'tabs',
      friendlyName: 'Enable navigation tabs',
      helperText: 'This will enable and show the navigation tab buttons',
      type: 'boolean',
      defaultValue: false,
    },
  ],
}
